import React, { useRef } from 'react';
import './index.less';
import utils from '@/common/utils';
import { Button, Dropdown, Menu } from 'antd';
// import { VerticalAlignTopOutlined } from '@ant-design/icons';
import allMethodsGoTo, { goto } from '@/common/goto';

export const interChannel = (item: any) => {
  if (item.linkType === 1) {
    // 跳转后端给的固定连接-内部链接
    goto(item.operationLink + '?channelId=' + item.channelId, 'newTab');
  } else if (item.linkType === 2) {
    // 跳转后端给的固定连接-外部链接
    goto(item.operationLink, 'newTab');
  } else if (item.linkType === 3) {
    // 跳转频道活动列表页
    if (item.channelType == 4) {
      // 行业频道
      allMethodsGoTo.channelList(item.channelId).newTab();
    } else {
      goto(`/platform-marketing/${item.channelId}`, 'newTab');
    }
  }
};

function PlatformMarketingEntry(props: any) {
  const { data } = props;
  const ref = useRef(null);
  const menu = (list: any) => {
    const menuList = list.slice(1);
    return menuList.length ? (
      <Menu className="platform-marketing-entry-menu">
        {menuList.map((item: any) => {
          return (
            <Menu.Item key={item.id} className="menu-item">
              <div className="menu-item-wrapper">
                <div className="menu-item-name ellipsis-1-line">
                  {/* <VerticalAlignTopOutlined className="up-icon" /> */}
                  {item.name}
                </div>
                <a onClick={() => interChannel(item)}>
                  <Button shape="round" type="primary">
                    立即进入
                  </Button>
                </a>
              </div>
            </Menu.Item>
          );
        })}
      </Menu>
    ) : (
      <Menu className="platform-marketing-entry-menu-hide" />
    );
  };
  return (
    <div ref={ref} className="platform-marketing-wrapper">
      <Dropdown
        placement="bottomCenter"
        overlay={menu(data.list)}
        getPopupContainer={() => ref.current || document.body}
      >
        <div className="platform-marketing-entry">
          <img
            className="back-img"
            src={utils.resizeImg(
              '//img30.360buyimg.com/pop/jfs/t1/146520/31/20767/37892/620a3eaeE2039067e/be16265b35cd508e.png',
              304,
              86
            )}
          />
          <div className="platform-marketing-entry-content">
            <div className="left">
              <div className="top-description">我管理的频道（{data.count}）</div>
              <div className="content-title">{data.list[0].name}</div>
            </div>
            <a onClick={() => interChannel(data.list[0])}>
              <Button className="entry-btn" shape="round">
                立即进入
              </Button>
            </a>
          </div>
        </div>
      </Dropdown>
    </div>
  );
}

export default PlatformMarketingEntry;
